import React from 'react';
import { formatDate, getReasonText } from '~/util';
import { Answer, Remove, Unanswer } from '~/components/Patient';
import { useRoleActions } from '~/util/useRoleActions';

interface DetailAttestationInfoProps {
    riskGap: RiskGapType;
    answer: null | boolean | undefined;
    patientId: number;
    handleInputChange: (e: {
        target: {
            value: boolean;
        };
    }) => void;
    handleClose: () => void;
}

export function DetailAttestationInfo({
    riskGap,
    answer = null,
    patientId,
    handleInputChange,
    handleClose,
}: DetailAttestationInfoProps) {
    const rolePermission = useRoleActions('allow_save_edit_answer_risk_gap', null);

    return (
        <>
            {!rolePermission && (
                <div className="permissions-alert">
                    You don’t have permission to save responses on this record.
                </div>
            )}
            <div className="large-modal-scroll">
                <p className="text-break">
                    <strong>Description</strong>
                    <br />
                    {riskGap?.icd?.description}
                    {riskGap?.description}
                </p>
                {riskGap.diagnosis_location && (
                    <p>
                        <strong>Location</strong>
                        <br />
                        {riskGap.diagnosis_location}
                    </p>
                )}
                {riskGap.referral_date && (
                    <p>
                        <strong>Ref. Date</strong>
                        <br />
                        {formatDate(riskGap.referral_date)}
                    </p>
                )}
                {(riskGap.reason || riskGap.is_utp || riskGap.return_comment) && (
                    <p>
                        <strong>Reason</strong>
                        <br />
                        {getReasonText(riskGap)}
                    </p>
                )}
                {riskGap.bookmark_link && (
                    <p>
                        <strong>Ref. Doc Available</strong>
                        <br />
                        {riskGap.bookmark_link}
                    </p>
                )}
                <div className="mb-3 text-center">
                    <Answer
                        hcc={riskGap}
                        inline
                        answer={answer}
                        handleInputChange={handleInputChange}
                    />
                </div>
                <Unanswer hcc={riskGap} patientId={patientId} />
                <Remove riskGap={riskGap} patientId={patientId} handleClose={handleClose} />
            </div>
        </>
    );
}
